import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

/* The routed page, remounted on `kipara:soft-refresh` (app back after a long
 * background stay, see src/autoRefresh.js): the page fetches again — from the
 * API cache when nothing changed — without reloading the whole app. */
export default function RefreshableOutlet() {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const onRefresh = () => setTick((t) => t + 1);
    window.addEventListener('kipara:soft-refresh', onRefresh);
    return () => window.removeEventListener('kipara:soft-refresh', onRefresh);
  }, []);
  return <React.Fragment key={tick}><Outlet /></React.Fragment>;
}
